var scope_0 = require('C:/Users/Alex/Desktop/Projects/Omniscia/proj-cross-mint-solidity.git/omniscia-report/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_1 = require('C:/Users/Alex/Desktop/Projects/Omniscia/proj-cross-mint-solidity.git/omniscia-report/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f547e8c8cf829a2af24c852ba8d52fac.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    